import React, {useEffect} from "react";
import {useChatStore} from "../store/chatbotStore";
import './chatbotSidebar.css';
import {useSelector} from "react-redux";
import users from "../../users";
import {cn} from "../../../utils/utils";
import {useNavigate} from "react-router-dom";
import {ChatbotApi} from "../../../apis/chatbot/towersChatbotApi";

const ChatbotSidebar = () => {

    const {
        conversations,
        currentConversation,
        setConversations,
        setCurrentConversation,
        hasPermission
    } = useChatStore();
    const darkMode = useSelector(users.selectors.isDarkMode);
    const navigate = useNavigate();

    useEffect(() => {
        ChatbotApi.getAllConversations().then((convs) => {
            setConversations(convs.conversations || []);
        }).catch((err) => {
            console.error("Error fetching conversations:", err);
            setConversations([]); // Clear conversations on error
        });

        return () => {
            setConversations([]); // Clear conversations on unmount
        }
    }, [setConversations]);

    return (
        <>
            <div className={cn("chatbot-sidebar", {"chatbot-sidebar-dark": darkMode})}>
                <div className="chatbot-sidebar__header">
                    <button className="chatbot-sidebar__header-button" onClick={() => {
                        navigate("/chatbot");
                        setCurrentConversation(null);
                    }}>
                        <i className="fa-regular fa-pen-to-square"></i> Nuevo chat
                    </button>
                </div>
                <div className={cn("chatbot-sidebar__container")}>
                    {conversations.map((conv) => (
                        <div
                            key={conv.id}
                            className={`chatbot-sidebar__conversation ${currentConversation === conv.id ? 'active' : ''}`}
                            onClick={() => setCurrentConversation(conv.id)}
                        >
                            <div className="chatbot-sidebar__conversation-title">
                                {conv.title || "Sin título"}
                            </div>
                            <div className="chatbot-sidebar__conversation-meta">
                                {new Date(conv.lastMessageAt).toLocaleString()}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default ChatbotSidebar;
